export default __webpack_public_path__ + "static/media/menu-main.6dfcfd01.svg";